import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDisplayDateTime } from '../../../utils/formatDisplayDateTime';
import { resolvedAdvisorCaseTypeLabel } from '../../../utils/unifiedCaseTypeLabel';

export default function CaseHistoryTable({ rows = [], members = [], cases = [] }) {
  const { t, i18n } = useTranslation();
  const mergedRows = rows.length
    ? rows
    : cases
        .map((c) => {
          const member = members.find((m) => String(m.id) === String(c.user_id));
          return {
            id: `${c.user_id}-${c.session_id}`,
            case_name: c.form_name || c.form_type || t('advisorPortal.caseLabelFallback'),
            status: c.status || 'New',
            updated_at: c.updated_at || c.created_at || null,
            member_name: member?.name || `User ${c.user_id}`,
          };
        });

  return (
    <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-slate-500">
          <tr>
            <th className="text-left p-3">{t('advisorPortal.familyCaseMember')}</th>
            <th className="text-left p-3">{t('advisorPortal.familyCaseCase')}</th>
            <th className="text-left p-3">{t('advisorPortal.familyCaseStatus')}</th>
            <th className="text-left p-3">{t('advisorPortal.familyCaseUpdated')}</th>
          </tr>
        </thead>
        <tbody>
          {!mergedRows.length ? (
            <tr>
              <td colSpan={4} className="p-8 text-center text-slate-400 text-sm">{t('advisorPortal.familyNoCaseHistory')}</td>
            </tr>
          ) : (
            mergedRows.map((r, i) => (
              <tr key={r.id || i} className="border-t border-slate-100">
                <td className="p-3 text-slate-700">{r.member_name || '-'}</td>
                <td className="p-3">{resolvedAdvisorCaseTypeLabel(r.case_name || r.form_name, t)}</td>
                <td className="p-3">{r.status || '-'}</td>
                <td className="p-3">
                  {r.updated_at ? formatDisplayDateTime(r.updated_at, i18n.language) : '-'}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

